<script setup>
import Header from './components/layouts/Header.vue'
import Footer from './components/layouts/Footer.vue';
import Countdown from './components/layouts/Countdown.vue';
// import Placeholder from './components/Placeholder.vue';
</script>

<template>
  <Header />
  <!-- <Countdown yellowTitle="101: " whiteTitle="Industrial AI Skills, Get Ready!"
    description="A first-of-its-kind, independent training platform built to meet the evolving needs of GCC industries."
    endDate="endDate= December 1, 2025 00:00:00" /> -->
  <RouterView />
  <Footer />
  <!-- <Placeholder/> -->
</template>